import * as React from 'react';
import cn from 'classnames';
import b_ from 'b_';

export type NotificationLevel = 'info' | 'error';

export type Position = 'right' | 'bottom' | 'top' | 'bottomRight' | 'bottomLeftSticky';

const b = b_.with('notification');

interface Props extends React.HtmlHTMLAttributes<HTMLDivElement> {
  level?: NotificationLevel;
  position?: Position;
  notificationWidth?: number;
}

import './index.scss';

export const Notification: React.FC<Props> = ({
  className,
  children,
  level = 'info',
  position = 'right',
  notificationWidth,
  ...props
}) => {
  return (
    <div className={cn(className, b({ position, level }))} {...props}>
      <div className={b('content', { position, level, minWidth: notificationWidth })}>
        {children}
      </div>
    </div>
  );
};

export default Notification;
